import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiResponse} from '../../api/api-response';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerMicrosoftAdsService {
  private routePath = '/partner/microsoft-ads';

  constructor(
    protected apiClient: ApiClientService,
  ) {
  }

  getAuthenticationLink(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/authentication-link', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  setAuthenticationRedirect(redirectUri: string): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.post(this.routePath + '/authentication-redirect', {}, {redirectUri: redirectUri}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getConversionGoalsStatus(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/conversion-goal', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData().goals);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
